import { validateString } from './string';
/**
 * Creates a validator function that checks that the value is a `string` at least one character long.
 */
export const validateNonEmptyString = (value, logger, logLabel) => {
    return validateString({ minLength: 1 })(value, logger, logLabel);
};
//# sourceMappingURL=non-empty-string.js.map